import store from '@/store';
import axios from "axios";

class Global {
    constructor() {
    }

    static capacity(appendBlank = false) {
        let d = [
            {id: 1, name: '50L'},
            {id: 2, name: '60L'},
            {id: 3, name: '100L'},
            {id: 4, name: '250L'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static collectSystemColor(appendBlank = false) {
      let d = [
          {id: 1, color: 'background-color: #FF9900'},
          {id: 2, color: 'background-color: #FF99CC'},
          {id: 3, color: 'background-color: #00ABEA'},
          {id: 4, color: 'background-color: #00ABEA'},
          {id: 5, color: 'background-color: #FCF305'},
          {id: 6, color: 'background-color: #FFCC99'},
          {id: 7, color: 'background-color: #1FB714'},
      ];
      if (appendBlank) {
          d.unshift({id: '', color: ''});
      }
      return d;
    };

    static containerType(appendBlank = false) {
        let d = [
            {id: 1, name: '研究室所有'},
            {id: 3, name: '単発レンタル'},
            {id: 2, name: '継続レンタル'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static containerTypeUser(appendBlank = false) {
        let d = [
            {id: 1, name: '研究室所有'},
            {id: 3, name: '単発レンタル'},
            {id: 2, name: '継続レンタル'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static supplySourceSelect(supplySource) {
        let d = [];
        if (supplySource == "1") {
          d = [
            {id: 1, name: '豊中分室'},
          ];
        }
        if (supplySource == "2") {
          d = [
            {id: 2, name: '吹田分室'},
          ];
        }
        return d;
    };

    static supplySource() {
      let d = [
        {id: 1, name: '豊中分室'},
        {id: 2, name: '吹田分室'},
      ];
      return d;
    };

    static status(appendBlank = false) {
        let d = [
            {id: 0, name: '未'},
            {id: 1, name: '済'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static mail(appendBlank = false) {
        let d = [
            {id: 0, name: '未'},
            {id: 1, name: '済'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static departmentList(appendBlank = false) {
        let d = [
            {id: 1, name: '理学部'},
            {id: 2, name: '基礎工学部'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static collectSystem(appendBlank = false) {
        let d = [
            {id: 1, name: '理FG北'},
            {id: 2, name: '基J文理'},
            {id: 3, name: '基Bypass'},
            {id: 4, name: '基礎工'},
            {id: 5, name: '極限'},
            {id: 6, name: '理BCDHJ低強'},
            {id: 7, name: '熱RI'},
        ];
        if (appendBlank) {
            d.unshift({id: '', capacity: ''});
        }
        return d;
    };

    static yearList(appendBlank = false) {
      let startYear = 2020;
      let d = [];
      let date = new Date();
      let year = date.getFullYear()
      for (let i = startYear; i <= year; i++) {
          d.push({id: i, name: i + '年'});
      }
      if (appendBlank) {
          d.unshift({id: '', name: ''});
      }
      return d;
  };


    static ymd() {
        const date = new Date();
        return date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + (date.getDate())).slice(-2);
    }

    static hms() {
        const date = new Date();
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + (date.getMinutes())).slice(-2);
    }

    /**
     * 指定されたインデックスの値を返却する
     */
    static getGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    return store.getters.getPostParam[group][index][label];
                } else {
                    return store.getters.getPostParam[group][label];
                }
            } else {
                if (index != null) {
                    if (!store.getters.getPostParam[label]) {
                        return store.getters.getPostParam[label];
                    }
                    return store.getters.getPostParam[label][index];
                }
            }
            return store.getters.getPostParam[label];
        } catch (e) {
        }
        return '';
    }

    /**
     * 指定されたインデックスが存在するかを調べる
     */
    static hasGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    if (!store.getters.getPostParam[group][index][label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[group][label]) {
                        return false;
                    }
                }
                return true;
            } else if (index != null) {
                if (!store.getters.getPostParam[label]) {
                    if (!store.getters.getPostParam[label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[label][index]) {
                        return false;
                    }
                }
            } else {
                if (!store.getters.getPostParam[label]) {
                    return false;
                }
            }
            return true;
        } catch (e) {
        }
        return false;
    }

    /**
     * 消費税加算
     */
    static tax(price) {
        return parseInt(price * 1.1, 10);
    }

    /**
     * 数値のカンマ区切りを行う
     */
    static comma(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
}

export default Global;